// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"styles_paragraph__3wGBf","semiBold":"styles_semiBold__2TzeF","light":"styles_light__9qgfY"};